var render = function (_h,_vm) {var _c=_vm._c;return _c('b-card-body',{staticClass:"text-center"},[_c('b-spinner',{attrs:{"small":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }